import eventsUrlConstants from '../../constants/eventsUrlConstants'

const events = () => eventsUrlConstants.EVENT_URL
const eventById = (id: number) => `${events()}/${id}`

export default {
  events,
  eventById,
}
